import { MaintanceStatusReponse } from '@cpd-app/generated';

export const maintanceFeatureKey = 'maintance';

export interface MaintanceState {
  loading: boolean;
  maintance: MaintanceStatusReponse;
}

export const initialMaintanceState: MaintanceState = {
  loading: false,
  maintance: null,
};
